// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__303a3","productName":"Table_productName__2VxcS"};